<template>
<div>
    <div>
        <vs-button color="primary" type="flat" icon-pack="feather" icon="icon-arrow-left" @click="back">Regresar</vs-button>
    </div>
    <vx-card title="Nuevo Asesor" class="p-12">
        <div class="vx-row mb-6 pt-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Nombres</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" icon-pack="feather" icon="icon-user" icon-no-border v-model="adviser.adv_nombres" />
                <span class="text-danger text-sm" v-if="errors.length != 0 && errors.adv_nombres && errors.adv_nombres.length == 1">{{ errors.adv_nombres[0] }}</span>
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Apellidos</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input class="w-full" icon-pack="feather" icon="icon-user" icon-no-border v-model="adviser.adv_apellidos" />
                <span class="text-danger text-sm" v-if="errors.length != 0 && errors.adv_apellidos && errors.adv_apellidos.length == 1">{{ errors.adv_apellidos[0] }}</span>
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Correo</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input name="email" type="email" v-validate="'required|email|unique'" class="w-full" icon-pack="feather" icon="icon-mail" icon-no-border v-model="adviser.adv_email" />
                <span class="text-danger text-sm" v-if="errors.length != 0 && errors.adv_email && errors.adv_email.length == 1">{{ errors.adv_email[0] }}</span>
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Teléfono</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input type="phone" class="w-full" icon-pack="feather" icon="icon-smartphone" icon-no-border v-model="adviser.adv_phone" />
                <span class="text-danger text-sm" v-if="errors.length != 0 && errors.adv_phone && errors.adv_phone.length == 1">{{ errors.adv_phone[0] }}</span>
            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Rol</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <v-select v-model="adviser.adv_rol" :options="roles" :reduce="roles => roles.id" label="nombre" />
                <span class="text-danger text-sm" v-if="errors.length != 0 && errors.adv_rol && errors.adv_rol.length == 1">{{ errors.adv_rol[0] }}</span>

            </div>
        </div>
        <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 w-full">
                <span>Estado</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-switch v-model="adviser.adv_status">
                    <span slot="on">Activo</span>
                    <span slot="off">Off</span>
                </vs-switch>
            </div>
        </div>
        <div class="vx-row">
            <div class="grid grid-cols-1 w-full">
                <vs-button @click="setAdviser()" class="mr-3 mb-2 justify-self-end">Guardar</vs-button>
            </div>
        </div>
    </vx-card>
</div>
</template>

<script>
import vSelect from 'vue-select'
import setAsesor from "@/services/setAsesor";
export default {
    components: {
        'v-select': vSelect,
    },
    data() {
        return {
            adviser: {},
            roles: [{
                    id: 1,
                    nombre: 'Administrador'
                },
                {
                    id: 2,
                    nombre: 'Asesor'
                }
            ],
            errors: []
        }
    },
    mounted() {

    },
    methods: {
        back() {
            var menu = {
                list: true,
                new: false
            }
            this.$emit('item', menu)
        },
        async setAdviser() {
            let {
                data
            } = await setAsesor(this.adviser)
            if (data.error) {
                this.errors = data.error
                console.log(this.errors)
            } else {
                this.$vs.notify({
                    color: 'success',
                    title: 'Guardado',
                    text: 'Asesor guadado.'
                })
                var menu = {
                    list: true,
                    new: false
                }
                this.$emit('item', menu)
            }
        }
    },
}
</script>
